import apiPath from '../../../config/api';

const PurchasePath = {
    title: "Permata - Modul Pembelian",
    basePath: "/permata/pembelian",
    newPath: "/permata/pembelian/baru",
    detailPath: "/permata/pembelian/opsi/:id",
    newUnit: "/master/satuan/baru",
    base: apiPath.retailPurchase,
    baseHistory: apiPath.retailPurchaseHistory,
    custFind: apiPath.masterCustFind,
    unitFilter: apiPath.masterUnitFilter,
    coaGns: apiPath.masterCoaGns,    
    apArFilterCustId: apiPath.accountApArCustIdFilter,
    gnsNmFilter: apiPath.masterGnsNmFilter,
    gnsCodeFilter: apiPath.masterGnsCodeFilter,
    gns: apiPath.masterGns,
    gnsFind: apiPath.masterGnsFind,
    excel: apiPath.retailPurchaseExcel,
    paymentMethodFind: apiPath.masterPaymentFind,
    
    unit: apiPath.masterUnit
}

export default PurchasePath;
